import type React from 'react';

import { FieldArray } from 'react-final-form-arrays';

import { cn } from '#src/app/shared/components/adminShadcn';
import type { NonI18nFieldValidator } from '#src/app/shared/form/validators';

import type { AudienceBuilderAllowedFilter, BaseFilterType } from '../shared/types';

import { OrFilterField } from './components/OrFilterField';
import type { AudienceFilterVariant } from './variantStyles';
import { AUDIENCE_FILTER_VARIANT_STYLES } from './variantStyles';

export const AudienceFilterField: React.FC<{
	label: string;
	fieldName: string;
	allowedFilters: readonly AudienceBuilderAllowedFilter[];
	filterValidator: NonI18nFieldValidator<BaseFilterType>;
	variant: AudienceFilterVariant;
}> = ({ label, fieldName, allowedFilters, filterValidator, variant }) => {
	const styles = AUDIENCE_FILTER_VARIANT_STYLES[variant];
	return (
		<div>
			<h3
				className={cn('admin:mb-2 admin:text-sm admin:font-bold admin:uppercase admin:tracking-wide', styles.heading)}
			>
				{label}
			</h3>
			<FieldArray
				name={fieldName}
				subscription={{ error: true, touched: true, value: true }}
				validate={(value, allValues) => filterValidator(value as BaseFilterType, allValues)}
			>
				{({ fields: fieldsAnd, meta }) => (
					<div className="admin:flex admin:flex-col admin:gap-4 admin:rounded-md admin:bg-slate-100 admin:p-4">
						{fieldsAnd.map((name, index) => (
							<OrFilterField
								// eslint-disable-next-line react/no-array-index-key
								key={index}
								name={name}
								allowedFilters={allowedFilters}
								fieldsAnd={fieldsAnd}
								index={index}
								variant={variant}
							/>
						))}
						{meta.touched && meta.error && typeof meta.error === 'string' ? (
							<p role="alert" className="admin:pt-1 admin:text-xs admin:text-destructive">
								{meta.error}
							</p>
						) : null}
						<button
							type="button"
							onClick={() =>
								fieldsAnd.push([
									{
										value: '',
										type: '',
									},
								])
							}
							className={cn(
								'admin:cursor-pointer admin:self-center admin:bg-transparent admin:text-sm admin:font-bold admin:underline admin:underline-offset-4',
								styles.actionLink,
							)}
						>
							+ AND
						</button>
					</div>
				)}
			</FieldArray>
		</div>
	);
};
